import { useStoreActions } from "../../../contexts";
import { useQueryState } from "../../../hooks/reactQuery/useQueryState";
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
export const useCanResyncQbo = _ref => {
  let {
    enabled,
    invoiceId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    data,
    isFetching,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.CanResyncQbo, invoiceId],
    queryFn: () => api.invoice.getResyncQboStatus(invoiceId),
    refreshOnMount: query => {
      var _query$state$data;
      return !!((_query$state$data = query.state.data) !== null && _query$state$data !== void 0 && _query$state$data.canResync);
    },
    enabled
  });
  return {
    canResyncQbo: !isFetching && !!(data !== null && data !== void 0 && data.canResync),
    refreshQbo: refresh
  };
};